import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {User} from 'main/stores/users';
import TimeOffRequest from './TimeOffRequest';
import {calendarDate} from 'shared/tools';

class TimeOffTransaction extends DomainObject {
  id;
  postedOn;
  transactionType;
  createdByUser;
  timeOffRequest;
  amount;
  notes;

  _relations = {
    _dates: ['postedOn'],
    createdByUser: User,
    timeOffRequest: TimeOffRequest
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      postedOn: observable,
      transactionType: observable,
      createdByUser: observable,
      timeOffRequest: observable,
      amount: observable,
      notes: observable,
      hasAmount: computed,
      postedOnView: computed
    });

    this.merge(other);
  }

  get hasAmount() {
    return this.amount !== null;
  }

  get postedOnView() {
    return calendarDate(this.postedOn);
  }
}

export default TimeOffTransaction;
